import { Box, useMediaQuery } from "@mui/material";
import Header from "components/Header";
import WidgetWrapper from "components/WidgetWrapper";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AssessmentReports from "pages/assessment/components/assessmentReports";
import CoachingFeedTable from "./components/coachingFeedTable";
import { useDispatch } from "react-redux";
import { fetchUser } from "reduxStore/actions/userActions";

function CoachingFeed() {
  const dispatch = useDispatch();
  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  // get the userID from the url
  const userId = useParams().userId;

  const user = useSelector((state) => state.user);
  const viewingUser = useSelector((state) => state.viewingUser);

  const viewingUserId = userId || user?._id;

  useEffect(() => {
    if (viewingUserId) {
      dispatch(fetchUser(viewingUserId, true));
    }
  }, [viewingUserId, dispatch]);

  const subtitle =
    userId === viewingUserId || !userId
      ? "Your coaching feed"
      : `${viewingUser?.firstName} ${viewingUser?.lastName}'s coaching feed`;

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <Header title="Coaching Feed" subtitle={subtitle} />

        <AssessmentReports
          isPrinciplesGraph={false}
          isCoachingFeed={true}
          viewingUserId={viewingUserId}
        />

        <CoachingFeedTable />
      </WidgetWrapper>
    </Box>
  );
}

export default CoachingFeed;
